import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useMemo } from "react";
import { getPartnerMarketingHomeBlocks } from "app/reducers/partnerSelector";
import SmartDP from "app/pages/SmartDP/SmartDP";
import { getQuoteStatus } from "app/pages/Booking/Quotation/quotationSelectors";
import {
	fetchSDPAvailableDepartureDate,
	fetchSDPFilters,
} from "app/pages/SmartDP/smartDPActionCreators";
import { getDestinationResort } from "app/pages/Booking/bookingSelectors";
import { generateHotelName } from "app/utils/productUtils";

const mapStateToProps = state => {
	const listingBasePath = "/sdp/listing";

	return {
		homeBlocks: getPartnerMarketingHomeBlocks(state),
		fetchSDPProductsStatus: state.smartDP.status,
		fetchSDPAvailabilitiesStatus: getQuoteStatus(state),
		hasSdpSpecialOffer: state.smartDP.specialOffer, // true si le back renvoi au moins un vol remboursable
		specialOfferInfos: state.smartDP.specialOfferInfos,
		destinationName: getDestinationResort(state)?.label,
		listingUrl:
			state.smartDP.listingUrl || `${listingBasePath}${state.smartDP.searchQueryString}`,
		hotelName:
			state.ficheProduit?.name &&
			generateHotelName(state.ficheProduit.name, state.ficheProduit.category),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchSDPFilters,
			fetchSDPAvailableDepartureDate,
		},
		dispatch
	);
};

const SmartDPContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);
	return <SmartDP {...props} {...stateProps} {...dispatchProps} />;
};

export default SmartDPContainer;
